import React, { useState } from 'react';
import TFFIcon from './TFFIcon';

interface props {
  accordionId: string;
  summaryChildren: React.ReactNode;
  controlText?: string;
  detailsChildren: React.ReactNode;
  actionsChildren?: React.ReactNode;
  detailsColor?: string;
  noStyle?: boolean;
  headerAlignBottom?: boolean;
}

const TFFAccordionNew: React.FC<props> = ({
  accordionId,
  summaryChildren,
  controlText,
  detailsChildren,
  actionsChildren,
  detailsColor,
  noStyle,
  headerAlignBottom,
}) => {
  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = () => {
    setIsChecked(prevState => !prevState);
  };
  return (
    <div
      style={
        noStyle
          ? {}
          : {
              width: '100%',
              border: '1px solid #BABABA',
              borderRadius: '5px',
              margin: '10px',
              position: 'relative',
              display: 'flex',
              alignItems: 'stretch',
              flexDirection: 'column',
              backgroundColor: 'white',
              boxShadow: 'none',
            }
      }
    >
      <article className="accordion" tabIndex={0} style={noStyle ? { backgroundColor: 'transparent' } : {}}>
        <input
          type="checkbox"
          name={`tui-accordion-for-${accordionId}`}
          id={`tui-accordion-for-${accordionId}`}
          tabIndex={-1}
          checked={isChecked}
          onChange={handleCheckboxChange}
        />
        <label
          className="header"
          htmlFor={`tui-accordion-for-${accordionId}`}
          style={
            noStyle
              ? { width: '160px', ...(headerAlignBottom ? { alignItems: 'flex-end' } : {}) }
              : { padding: '8px 16px', ...(headerAlignBottom ? { alignItems: 'flex-end' } : {}) }
          }
        >
          <span className="label" style={noStyle ? { padding: '0px' } : {}}>
            {summaryChildren}
          </span>
          {controlText && <span className="notification">{controlText}</span>}
          <span aria-label="Control" className="icon-accordion">
            <TFFIcon iconName="chevron-down" color="color-functional-base-600" />
          </span>
        </label>
        <section
          className="body"
          style={{ backgroundColor: detailsColor || '#E2F3FE', maxHeight: isChecked ? '100%' : '0vh' }}
        >
          <div className="content" style={noStyle ? {} : { padding: '25px 15px' }}>
            {detailsChildren}
          </div>
          {actionsChildren && (
            <div style={{ backgroundColor: 'white', padding: '16px', textAlign: 'right', justifyItems: 'flex-end' }}>
              {actionsChildren}
            </div>
          )}
        </section>
      </article>
    </div>
  );
};

export default TFFAccordionNew;
